import React from "react";
import { Link } from "react-router-dom";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { useT } from "@/context/LanguageContext";
import { ArrowUpRight } from "@phosphor-icons/react";

const PLATFORMS = [
  { name: "Alibaba", color: "#FF6A00" },
  { name: "Made-in-China", color: "#C8102E" },
  { name: "1688", color: "#FF4F00" },
  { name: "Pinduoduo", color: "#E02E24" },
  { name: "DHgate", color: "#12A150" },
  { name: "AliExpress", color: "#E43225" },
];

export function Marketplaces() {
  const { t } = useT();
  return (
    <section className="bg-mist py-24 lg:py-32" data-testid="marketplaces-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          overline={t("marketplaces.overline")}
          title={t("marketplaces.title")}
          subtitle={t("marketplaces.subtitle")}
          align="center"
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {PLATFORMS.map((p, i) => (
            <Reveal key={p.name} delay={(i % 3) * 0.07}>
              <Link
                to="/contact?type=quote"
                data-testid={`marketplace-${i}`}
                className="group flex h-full items-center justify-between gap-4 rounded-xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div>
                  <p className="font-heading text-2xl font-extrabold tracking-tight" style={{ color: p.color }}>
                    {p.name}
                  </p>
                  <p className="mt-1 text-sm text-slate-500">{t(`marketplaces.p${i}`)}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-ink opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    {t("marketplaces.cta")} <ArrowUpRight size={15} weight="bold" />
                  </span>
                </div>
                <span
                  className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: p.color }}
                >
                  <ArrowUpRight size={22} weight="bold" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
